import React from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader, Button } from 'reactstrap';
import ProgramList from './ProgramList';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

class ProgramSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            disableAddProgram: true,
            programIds: []
        };
    }

    handleAdd = () => {
        this.props.onAdd(this.state.programIds);
        this.setState({ disableAddProgram: true }); 
    }

    handleSelectionChanged = (ids) => {
        this.setState({ programIds: ids})
        this.setState({ disableAddProgram: !ids.length > 0 });
    }

    handleAddNew = () => {
        const { trainingId, fromTrainingPage, history, clearProgramState, setLocation } = this.props;
        if (!fromTrainingPage)
            setLocation(trainingId);
        clearProgramState();
        history.push('/programs/program');
    }

    render() {

        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.toggle}
                size='xl'
                scrollable={true}
            >
                <ModalHeader toggle={this.props.toggle}>Program Search</ModalHeader>
                <ModalBody>
                    <ProgramList
                        history={this.props.history}
                        getProgram={this.props.getProgram}
                        trainingPrograms={this.props.data}
                        onSelectionChanged={this.handleSelectionChanged}
                        rowSelection='multiple'
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleAddNew}>Add New</Button>{' '}
                    <Button color="primary" disabled={this.state.programIds.length === 0} onClick={this.handleAdd}>Add</Button>{' '}
                    <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default ProgramSearch